import customInput from './input.vue';
export default customInput;
